module.exports = __webpack_public_path__ + "static/media/grey-download.65d979c6.svg";